export default __webpack_public_path__ + "static/media/ford_ranger.7cf47776.jpg";